module.exports = __webpack_public_path__ + "static/img/IMG_20240805_205051.36c20644.jpg";